import React from 'react';

// The device joins wifi through its own captive-portal setup network. These three
// steps cover both first-time connect and re-connect/reset — the same flow. Kept
// in one place so the claim screen, dashboard offline banner, and the install
// page all show identical instructions.
// Matches the printed install guide ("water-tank-setup"). Keep this in lock-step
// with the SSID the firmware's captive portal actually broadcasts.
export const WIFI_SETUP_NETWORK = 'water-tank-setup';

export default function WifiSteps({ compact = false }) {
  return (
    <ol className={`wifi-steps${compact ? ' wifi-steps--compact' : ''}`}>
      <li>Hold the button on the device until all lights turn blue (about 8 seconds).</li>
      <li>On your phone, connect to the <strong>{WIFI_SETUP_NETWORK}</strong> wifi network.</li>
      <li>Enter your home wifi name and password when prompted.</li>
    </ol>
  );
}
